import React from 'react';
import Relay from 'react-relay';

import { Link } from 'react-router';
import { pure } from 'recompose';

type Props = {
  user: Object,
  from?: string,
  listIndex?: number,
};

export function buildShopLocation(username: string, id: number, from: ?string, listIndex: ?number) {
  return {
    pathname: `/${username}`,
    state: {
      userId: id,
      from,
      listIndex,
    },
  };
}

const ShopLink = ({user, from, relay, listIndex, ...props}: Props) => (
  <Link to={buildShopLocation(user.username, user.publicId, from, listIndex)} {...props} />
);

export default Relay.createContainer(pure(ShopLink), {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        publicId
        username
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/links/ShopLink.js